<template>
  <app-public>
    <app-auth>
      <v-flex
        xs12
        sm8
        md4
        lg4
      >
        <v-card
          flat
        >
          <v-card-text>
            <AppErrorAlert />
            <v-layout class="justify-center align-center">
              <v-responsive
                :class="{'pa-8': $vuetify.breakpoint.smAndUp}"
                :aspect-ratio="21/9"
                max-height="200px"
              >
                <v-img
                  :src="this.$options.filters.generateLogoURI()"
                  class="my-3"
                  contain
                />
              </v-responsive>
            </v-layout>
            <v-form :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
              <v-text-field
                @keyup="email = toLower(email)"
                prepend-icon="person"
                name="login"
                label="E-mail"
                type="text"
                v-model="email"
                flat
              />
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Senha"
                id="password"
                type="password"
                v-model="password"
                flat
              />
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <app-button
              :large="$vuetify.breakpoint.smAndUp"
              @click.native.prevent="logar"
            >
              Entrar
            </app-button>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-footer
        inset
        app
        dark
        height="auto"
        class="pa-3 app--footer"
      >
        <span class="caption">Coopermais &copy; {{ new Date().getFullYear() }}</span>
      </v-footer>
    </app-auth>
  </app-public>
</template>
<script>
import AppPublic from '@/components/layouts/AppPublic'
import AppAuth from '@/components/layouts/AppAuth'
import AppErrorAlert from '@/components/AppErrorAlert'
import AppButton from '@/components/AppButton'
import { mapActions } from 'vuex'
export default {
  components: {
    AppPublic,
    AppAuth,
    AppErrorAlert,
    AppButton
  },
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    ...mapActions(['login']),
    toLower (text) {
      return text.toLowerCase()
    },
    logar () {
      this.login({ email: this.email, password: this.password })
        .then(resp => {
          this.$router.push({
            name: 'dashboard-index'
          })
        })
    }
  }
}
</script>
